import {makeNoAuthApiClient} from '@practicegenius/http-clients-js/src/ApiClient';
import {PG_CORE_URL} from '../constants/env';

export const coreApiClientNoAuth = makeNoAuthApiClient({
  baseURL: PG_CORE_URL,
});
